import { expectArray, expectBoolean, expectNumber, expectOptionalString, expectRecord, expectString } from "./schema";
export const FAMILY_SCHEDULE_ITEM_TYPES = ["occurrence", "event"];
export const FAMILY_SCHEDULE_VIEW_MODES = ["siblingMergedChronological"];
function parseStringEnum(value, allowedValues, path) {
    const parsed = expectString(value, path);
    if (!allowedValues.includes(parsed)) {
        throw new Error(`${path} must be one of: ${allowedValues.join(", ")}`);
    }
    return parsed;
}
export function parseFamilyScheduleItemType(value, path = "scheduleItemType") {
    return parseStringEnum(value, FAMILY_SCHEDULE_ITEM_TYPES, path);
}
export function parseFamilyScheduleViewMode(value, path = "scheduleViewMode") {
    return parseStringEnum(value, FAMILY_SCHEDULE_VIEW_MODES, path);
}
export function parseFamilyScheduleDisplayFlags(value, path = "familyScheduleDisplayFlags") {
    const record = expectRecord(value, path);
    return {
        isCancelled: expectBoolean(record.isCancelled, `${path}.isCancelled`),
        isChanged: expectBoolean(record.isChanged, `${path}.isChanged`),
        hasPublicNote: expectBoolean(record.hasPublicNote, `${path}.hasPublicNote`),
        showStudio: expectBoolean(record.showStudio, `${path}.showStudio`),
        showTeacherNames: expectBoolean(record.showTeacherNames, `${path}.showTeacherNames`)
    };
}
export function parseStudentSummary(value, path = "studentSummary") {
    const record = expectRecord(value, path);
    return {
        studentId: expectString(record.studentId, `${path}.studentId`),
        displayName: expectString(record.displayName, `${path}.displayName`),
        displayNameKana: expectOptionalString(record.displayNameKana, `${path}.displayNameKana`),
        birthDate: expectOptionalString(record.birthDate, `${path}.birthDate`),
        status: expectString(record.status, `${path}.status`),
        familyAccountId: expectOptionalString(record.familyAccountId, `${path}.familyAccountId`),
        nextScheduledAt: expectOptionalString(record.nextScheduledAt, `${path}.nextScheduledAt`),
        upcomingCount: expectNumber(record.upcomingCount, `${path}.upcomingCount`)
    };
}
export function parseFamilyScheduleItem(value, path = "familyScheduleItem") {
    const record = expectRecord(value, path);
    return {
        itemId: expectString(record.itemId, `${path}.itemId`),
        itemType: parseFamilyScheduleItemType(record.itemType, `${path}.itemType`),
        title: expectString(record.title, `${path}.title`),
        startAt: expectString(record.startAt, `${path}.startAt`),
        endAt: expectString(record.endAt, `${path}.endAt`),
        locationLabel: expectOptionalString(record.locationLabel, `${path}.locationLabel`),
        teacherNameSnapshots: expectArray(record.teacherNameSnapshots, expectString, `${path}.teacherNameSnapshots`),
        publicNote: expectOptionalString(record.publicNote, `${path}.publicNote`),
        studentIds: expectArray(record.studentIds, expectString, `${path}.studentIds`),
        studentDisplayNames: expectArray(record.studentDisplayNames, expectString, `${path}.studentDisplayNames`),
        displayFlags: parseFamilyScheduleDisplayFlags(record.displayFlags, `${path}.displayFlags`)
    };
}
export function parseFamilyScheduleMonthGroup(value, path = "familyScheduleMonthGroup") {
    const record = expectRecord(value, path);
    return {
        yearMonth: expectString(record.yearMonth, `${path}.yearMonth`),
        label: expectString(record.label, `${path}.label`),
        items: expectArray(record.items, parseFamilyScheduleItem, `${path}.items`)
    };
}
export function parseFamilyScheduleResponse(value, path = "familyScheduleResponse") {
    const record = expectRecord(value, path);
    return {
        rangeStart: expectString(record.rangeStart, `${path}.rangeStart`),
        rangeEnd: expectString(record.rangeEnd, `${path}.rangeEnd`),
        viewMode: parseFamilyScheduleViewMode(record.viewMode, `${path}.viewMode`),
        monthGroups: expectArray(record.monthGroups, parseFamilyScheduleMonthGroup, `${path}.monthGroups`)
    };
}
export function parseFamilyDashboardResponse(value, path = "familyDashboardResponse") {
    const record = expectRecord(value, path);
    return {
        studentSummaries: expectArray(record.studentSummaries, parseStudentSummary, `${path}.studentSummaries`),
        upcomingItems: expectArray(record.upcomingItems, parseFamilyScheduleItem, `${path}.upcomingItems`),
        updatedAt: expectString(record.updatedAt, `${path}.updatedAt`)
    };
}
export function parseFamilyStudentsResponse(value, path = "familyStudentsResponse") {
    const record = expectRecord(value, path);
    return {
        items: expectArray(record.items, parseStudentSummary, `${path}.items`)
    };
}
export function parseFamilyStudentDetail(value, path = "familyStudentDetail") {
    const record = expectRecord(value, path);
    return {
        student: parseStudentSummary(record.student, `${path}.student`),
        upcomingItems: expectArray(record.upcomingItems, parseFamilyScheduleItem, `${path}.upcomingItems`)
    };
}
